import { types as t, flow } from 'mobx-state-tree';

import { withEnv } from 'models/withEnv';

export const AsanaSettings = t
  .model('AsanaSettings', {
    token: '',
    hasToken: false,
  })
  .views(withEnv)
  .actions((self) => ({
    afterCreate() {
      self.getHasToken();
    },
    setToken(token) {
      self.token = token;
    },
    getHasToken: flow(function* () {
      const res = yield self.env.api.integrations.asanaHasToken();
      if (!res.error) {
        self.hasToken = res.data.hasToken;
      }
    }),
    submitToken: flow(function* () {
      const res = yield self.env.api.integrations.asanaSubmitToken(self.token);
      if (res.status === 200) {
        self.hasToken = true;
        self.env.showSuccess(self.env.t('integrations.asana.settings.save.success'));
      } else {
        self.env.showError(self.env.t('integrations.asana.settings.save.error'));
      }
      return res;
    }),
  }));
